import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import strings from 'owa-strings/owa-mini-common-strings';
import { format } from 'owa-strings';

export const getWindowTitle = (moduleName: string = 'Mail') =>
    format(
        strings.windowTitleFormatString,
        moduleName,
        getUserConfiguration().SessionSettings.UserDisplayName
    );
